import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from 'rxjs/operators';
import { isDemoUrl } from "./url-helpers";

@Injectable()
export class FootPortalHttpInterceptor implements HttpInterceptor {
  constructor(private router: Router) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // work out what url the application is running from and choose an api url for the appropriate site
    let apiUrl: string

    let subdomain: string;
    subdomain = window.location.host.split(".")[0];
    if (subdomain.includes("thefoodchecker")) subdomain = null;

    const url = window.location.href;

    // select the api url based on the url of the site, this allows us to use the same codebase for all environments and select the correct api based on the url.

    // the dev site should match dev.thefoodchecker.com and use 'glt-primary' as the subdomain
    if (url.includes("dev.thefoodchecker.com")) { 
      apiUrl = "https://dev.pelicanpi.co.uk";
      subdomain = 'glt-primary';

      // the demo site should match demo.thefoodchecker.com, demo-{anything}.thefoodchecker.com or pifoodportaldemo.azurewebsites.net
    } else if (isDemoUrl(url)) { 
      apiUrl = "https://demo.pelicanpi.co.uk";

      // everthing else under thefoodchecker.com should be production
    } else if (url.includes("thefoodchecker.com")) { 
      apiUrl = "https://www.pelicanpi.co.uk";

      // for any other url we are debugging locally using urbanvillagepubs as the subdomain - this can be reconfigured for local testing
    } else { 
      apiUrl = "https://localhost:44358";
      subdomain = "urbanvillagepubs";
    }

    const serverHostURL = apiUrl + "/api/allergenportal/";


    if (!subdomain) {
      this.router.navigate(["promote"]);
    }

    request = request.clone({
      url: serverHostURL + request.url,
    });
    //if GetPortalSettings then add the subdomain
    if (request.url.indexOf("GetPortalSettings") > -1) {
      request = request.clone({
        body: { ...request.body, subdomain: subdomain },
      });
    }

    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (event.status === 204) {
              this.router.navigateByUrl("/promote", {
                skipLocationChange: true,
              });
              this.router.navigate(["promote"]);
            }
            return event;
          }
          return event;
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            return err;
          }
        }
      )
    );
  }
}
